import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "image"]
  
  connect() {
    document.addEventListener("keydown", this.handleKeyDown)
  }
  
  disconnect() {
    document.removeEventListener("keydown", this.handleKeyDown)
  }
  
  handleKeyDown = (e) => {
    if (e.key === "Escape") {
      this.close()
    }
  }
  
  open(event) {
    const imageUrl = event.currentTarget.src
    const imageAlt = event.currentTarget.alt
    
    this.imageTarget.src = imageUrl
    this.imageTarget.alt = imageAlt
    
    this.modalTarget.classList.remove("hidden")
    
    document.body.style.overflow = "hidden"
  }
  
  close() {
    // Esconde o modal
    this.modalTarget.classList.add("hidden")
    
    // Restaura o scroll do body
    document.body.style.overflow = ""
  }
}